import {btn_sm, btn_md, btn_lg, svg_inline, svg_xs, svg_sm, svg_md, font_s_sm, font_s_md, font_s_lg} from '../../styleGuide';

const button = {fontWeight: 'bold'};
const svg = {...svg_inline}
const text = {display: 'inline-block'}

export default {
  button_sm: {
    ...button,
    ...btn_sm,
  },
  text_sm: {
    ...text,
    ...font_s_sm,
  },
  icon_sm: {
    ...svg,
    ...svg_xs,
  },
  button_md: {
    ...button,
    ...btn_md,
  },
  text_md: {
    ...text,
    ...font_s_md,
    marginTop: '.1rem',
  },
  icon_md: {
    ...svg,
    ...svg_sm,
    marginRight: '.8rem'
  },
  button_lg: {
    ...button,
    ...btn_lg,
  },
  text_lg: {
    ...text,
    ...font_s_lg,
    marginTop: '.2rem',
  },
  icon_lg: {
    ...svg,
    ...svg_md,
    marginRight: '1rem'
  },
  iconRight: {
    float: 'right',
    marginRight: 0,
  }
}
